import React from "react";
import {PAI_ANIMATION_BG_TYPE} from "./constants";
import Particle from "./components/Particle";

const PaiAnimationBg: React.FC<any> = (props) => {
    const {type = '', height = 0} = props
    switch (type) {
        case PAI_ANIMATION_BG_TYPE.PARTICLE_BG:
            return <Particle height={height} />
        default:
            return <></>
    }
}

export default React.memo(PaiAnimationBg)